<template>
  <div>
    <!-- {{MultiblTableArray}} -->
    <div class="box" v-if="MultiblTableArray.length > 0">
      <div class="box-header">
        <label class="box-title">
          <u>Multi BL Details</u>
        </label>
      </div>
      <div class="box-body">
        <table id="MultiBl" class="table table-bordered">
          <thead>
            <tr>
              <th>SN.</th>
              <th>BL No.</th>
              <th>BL Type</th>
              <th>BL Stage</th>
              <th>Consignor</th>
              <th>Consignee</th>
              <th>PDF</th>
              <th>Word</th>
              <th>Edit BL Request</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in MultiblTableArray" :key="index">
              <td>{{ index + 1 }}</td>
              <td class="showMoreData">
                <!-- @click="viewEditBLNonUs(item, index)" -->
                <span style="color: blue;font-weight-bold;font-size:15px;" @click="viewEditBLNonUs(item, index)">
                  <!-- {{item}} -->
                  <u>{{ item.billLading + item.billLadingSeries }}&nbsp;&nbsp;&nbsp;&nbsp;<button style="font-size:15px;" type="button" class="btn btn-outline-info btn-sm"><i aria-hidden="true" class="md-icon md-theme-default material-icons">edit</i></button></u></span
                ><br />
                <span v-if="item.createdBy">Created By : {{ item.createdBy }}<br /></span>
                <span v-if="item.CreatedAt" >Created At : {{ item.CreatedAt }}<br /></span>
                <span v-if="item.UpdatedBy">Updated By : {{ item.UpdatedBy }}<br /></span>
                <span v-if="item.UpdatedAt">Updated At : {{ item.UpdatedAt }}<br /></span>
              </td>
              <td>{{ item.typeOfBL == "1" ? "House BL" : "Linear BL" }}</td>
              <td>{{ item.blStage }}</td>
              <td>
                <span v-html="item.consignor">{{ item.consignor }}</span>
              </td>
              <td>
                <span v-html="item.consignee">{{ item.consignee }}</span>
              </td>
              <td>
                <b-button
                  style="margin-left: 5px"
                  v-if="item.fclBlId != ''"
                  @click="Print(item.uploadBL)"
                  size="sm"
                  variant="warning"
                  >B/L PDF</b-button
                >
              </td>
              <td>
                <b-button
                  style="margin-left: 5px"
                  @click="downloadWord(item,item.fclBlId)"
                  v-if="item.fclBlId != ''"
                  size="sm"
                  variant="warning"
                  >B/L Word</b-button
                >
              </td>
              <td>
                <div :id="'row' + item.fclBlId">
                      <md-switch
                      v-if="$sessionsStorage.get('designation') == 'Admin' &&
                          $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                        :id="'approval' + item.fclBlId"
                        name="approval"
                        class="md-primary"
                        :value="item.isActiveBL == 1 ? true : false"
                        @change="activateUser(item)"
                      >
                        <h6>
                          <br />
                          <b-badge
                            :variant="item.isActiveBL == 1 ? 'success' : 'danger'"
                            >{{
                              item.isActiveBL == 1 ? "Active" : "In-Active"
                            }}</b-badge
                          >
                        </h6>
                      </md-switch>
                    </div>
                <b-button
                  v-if="
                    item.fclBlId != '' &&
                    item.fclBlId != undefined &&
                    item.originalDone == true
                  "
                  @click="EditBLRequest(item)"
                  size="sm"
                  variant="warning"
                  > Edit BL Request</b-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMultiPreAlertMail"
      ref="popMail"
    ></md-dialog-confirm>
    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="openMultiPreAlert"
      ref="popMultiBlStageMail"
    ></md-dialog-confirm> -->
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMultiMailAfter"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMultiBLApprovalMail"
      ref="popMultiBLMail"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import ClientUserService from '../../services/ClientUserService';

export default {
  props: [
    "Multi_BL_fk_all_module_id",
    "Multi_BL_jb_series",
    "Multi_BL_ffExportFclId",
    "Multi_BL_ffExecutionId",
    "Multi_BL_ffBookingId",
    "Multi_BL_title",
  ],
  beforeMount() {
    // alert(this.Multi_BL_ffExportFclId)
    if (
      this.Multi_BL_ffExportFclId != "" &&
      this.Multi_BL_ffExecutionId != "" &&
      this.Multi_BL_ffBookingId != ""
    ) {
      this.getData();
    }
  },
  mounted() {},

  data() {
    return {
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      all_module_id: this.Multi_BL_fk_all_module_id,
      ff_ExportFclId: this.Multi_BL_ffExportFclId,
      ff_ExecutionId: this.Multi_BL_ffExecutionId,
      ff_BookingId: this.Multi_BL_ffBookingId,
      jb_series: this.Multi_BL_jb_series,
      docURL: URL_BASE_DOC,
      MultiblTableArray: [],
      SingleBLDetails:{},
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    activateUser(item) {
      this.itemObj = item;

      this.itemObj.isActiveBL = this.itemObj.isActiveBL == 1 ? 0 : 1;
      let paylod = {
        tableName: "fcl_bl_raised",
        tableId: "fclBlId",
        tableIsActive: "isActiveBL",
        value1: this.itemObj.isActiveBL,
        tableVal: item.fclBlId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.MultiblTableArray=[];
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    viewEditBLNonUs(item, index) {
      this.$sessionsStorage.set("editfclBlId","");
      this.$sessionsStorage.set("editfclBlId",item.fclBlId);
      if ((item.portLocationType == "NON_USA")) {
        this.$router.push({
          path: "/freightForward/BL-NonUS",
        });
      } else if ((item.portLocationType == "USA")) {
        this.$router.push({
          path: "/freightForward/BL-US",
        });
      }
    },
    sendMultiBLApprovalMail(type) {
      // console.log("SingleBLDetails=>",this.SingleBLDetails);
      // return false;
      if (type != "cancel") {
        this.isLoading = true;
        // let containerNoArry = [];
        // this.containerTypeDetailFactory.map((x) => {
        //   containerNoArry.push(x.containerNo);
        // });

        let newData = {
          mailBLApproval: "BLApprovalMail",
          BLNO: this.SingleBLDetails.fclBlId,
          assignmentNo: this.Multi_BL_jb_series,
          fk_all_module_id: this.Multi_BL_fk_all_module_id,
          ff_ExportFclId: this.Multi_BL_ffExportFclId,
          BLSERIES: this.SingleBLDetails.billLading+this.SingleBLDetails.billLadingSeries,
          shipper:this.SingleBLDetails.consignor,
          consignee:this.SingleBLDetails.consignee,
          consignor:this.SingleBLDetails.consignor,
        };
        // console.log("newData=>",newData);
      // return false;
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendBLApproval_VP.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              console.log(data);
              this.alert.content = "Mail Sent";
              this.$refs["popMultiMailAfter"].open();
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    sendMultiPreAlertMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map((x) => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailPreAlert: "PreAlrt",
          clientName: this.allData[0].clientName,
          shippingLine: this.allData[0].shippingLine,
          overseasClient: this.allData[0].overseasClient,
          assignmentNo: this.allData[0].ffExportFclSeries,
          shipmentType: this.allData[0].containerInfo,
          FinalPlace: this.BLRaised.placeDilievery,
          consignee: this.BLRaised.consignee,
          vesselVoy: this.BLRaised.vesselVoy,
          containerNoArry: containerNoArry,
        };

        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/sendPreAlertMailBL.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;

              this.alert.content = "Mail Sent";
              this.$refs["popMultiMailAfter"].open();
              this.savegenerateblprealertStatus = false;
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    EditBLRequest(item) {
      this.SingleBLDetails = {};
      this.SingleBLDetails = item;
      this.alert.content = "Send Edit BL Request";
      this.$refs["popMultiBLMail"].open();
    },
    sendBLApprovalMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map((x) => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailBLApproval: "BLApprovalMail",
          BLNO: this.BLRaised.fclBlId,
          assignmentNo: this.allData[0].ffExportFclSeries,
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendBLApproval.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              console.log(data);
              this.alert.content = "Mail Sent";
              this.$refs["popMultiMailAfter"].open();
              // this.savegenerateblprealertStatus=false;
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    Print(item) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.Multi_BL_jb_series.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },
    downloadWord(item,id) {
      // alert(item.portLocationType)
      if ((item.portLocationType == "NON_USA")) {
        window.location =`${URL_BASE}/Api_FFSeaExport/wordBLNonUS.php?id=` + id;
      } else if ((item.portLocationType == "USA")) {
       window.location =`${this.URL_BASE}/Api_FFSeaExport/wordBLUs.php?id=` + id;
      }
      

      //  "http://13.229.240.246/pridelApiNew/Freight/wordBLNonUS.php?id=" + id;
      //"http://localhost:80/pridel-api/Freight/wordBLNonUS.php?id=" + id;
    },
    getData() {
      let type_Size = {
        itemCode: "itemCode",
        itemCode2: "CommonMULTIBL",
        ffExportFclId: this.Multi_BL_ffExportFclId,
        ffExecutionId: this.Multi_BL_ffExecutionId,
        ffBookingId: this.Multi_BL_ffBookingId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/fetchtoMultiBLList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // Added By Priyanshu SIngh Start 18-10-2022

            if (data.BLNonData.length > 0) {
              // this.MultiblTableArray = [];
              data.BLNonData.forEach((element) => {
                element["originalDone"] = false;
                if (
                  element.fclBlId != "" &&
                  element.fclBlId != undefined &&
                  (element.blStage == "ORIGINAL" || element.blStage == "SEAWAY")
                ) {
                  element["originalDone"] = true;
                  if (element.mail_approved_status == "1") {
                    element["originalDone"] = false;
                  }
                }

                this.MultiblTableArray.push(element);
              });
            }
            // console.log(
            //   "this.MultiblTableArray Multi=>",
            //   this.MultiblTableArray
            // );
            // Added By Priyanshu SIngh Start 18-10-2022
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// multiBl.vue?759fb670